
import { Clause1Home } from "../../pages/clause1";

export const clause1 = [
  {
    path: 'clause1',
    element: <Clause1Home />,
  },
];
